<app-header-user></app-header-user>
<section class="account-page mrgn-top greybg py-5">
    <div class="container">
     <div class="">
      <div class="row mt-2 mt-md-0"> 
  
          <aside class="col-sm-6 col-md-4 col-lg-3">
            <app-userdashboard-sidebar>  </app-userdashboard-sidebar>  
                      </aside>
                      <div class="col-sm-6 col-md-8 col-lg-9 mt-3 mt-md-0 rside-text">
                        <app-userheading-section></app-userheading-section>
                            <form #profForm="ngForm" (ngSubmit)="onProfileUpdateSubmit(profForm)">
  
          <div class="profile-content p-3 p-md-4">
              <div class="row">
                <div class="col-md-12"><span class="errcls errclsmain">{{errmsg}}</span></div>
              <div class="col-md-12 mb-2">
              <label for="firstName">{{ 'myaccount.your_name' | translate }}<span class="text-danger">*</span></label>
              <input class="form-control" name="username" placeholder="{{ 'myaccount.your_name' | translate }}" [(ngModel)]="userdata['uName']" value="{{userdata['uName']}}">

              </div>
              </div>
          <div class="row">
              <div class="col-md-12 mb-2">
              <label for="firstName">{{ 'myaccount.email' | translate }}<span class="text-danger">*</span></label>
              <input type="email" class="form-control" name="email" placeholder="{{ 'myaccount.email' | translate }}" [(ngModel)]="userdata['uEmail']">
              </div>
              <div class="col-md-12 mb-3">
              <label for="lastName">{{ 'myaccount.phone' | translate }}<span class="text-danger">*</span></label>
              
                    <span class="country-code">971</span>
               
              <input type="text" name="userphone" placeholder="50 123 4567" maxlength="10" class="form-control phone-country" [(ngModel)]="uMobile" value="{{uMobile}}">
              
              </div>
              </div>
              <div class="row">
              <div class="col-md-6 mb-2">
              <label for="firstName">{{ 'myaccount.password' | translate }}</label>
              <input type="password" class="form-control" name="password" placeholder="{{ 'myaccount.password' | translate }}" ngModel>
              
              </div>
              <div class="col-md-6 mb-3">
              <label for="lastName">{{ 'myaccount.re_password' | translate }}</label>
              <input type="password" class="form-control" name="cnfpassword" placeholder="{{ 'myaccount.confirm_password' | translate }}" ngModel>
              
              </div>
              </div>

              
               <button type="submit" class="btn btn-primary comm-btn">{{ 'myaccount.submit' | translate }}
                <span *ngIf="isLoading">
                    <i class="fas fa-circle-notch fa-spin"></i>
                </span>
               </button>
              </div>
  </form>
  
  
                      </div>
                  </div>
              </div>
          </div>
</section>